/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as CustomWidgets from '.';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@mui/styles';
import { Button, ButtonGroup, Card, CardContent, CardHeader, Checkbox, Divider, FormControl, Grid, IconButton, InputLabel, List, ListItem, ListItemIcon, ListItemText, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Tooltip, Typography } from '@mui/material';
import { Add, Build, Edit, EditAttributes, Remove, Settings } from '@mui/icons-material';
import ReactJson from "react-json-view";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titlesTabs: {
            textRendering: "geometricPrecision",
            WebkitFontSmoothing: "antialiased !important",
            scrollBehavior: "smooth",
            fontFamily: "Muli,sans-serif !important",
            color: "#969BA0 !important",
            //fontWeight: 'bold'
        },
        contentTab: {
            padding: "10px !important",
        },
        firstTitle: {
            padding: "16px",
        },
        titleTable: {
            display: "flex",
            width: "100%",
        },
        buttonAdd: {
            marginLeft: "88% !important",
        },
        titleH2: {
            display: "flex",
        },
        iconTitle: {
            marginTop: "4px",
            marginRight: "5px",
        },
        textField: {
            marginLeft: theme.spacing(1),
            display: "flex !important",
            width: "25% !important",
            margin: "auto !important",
            marginRight: "0 !important",
        },
    })
);

const MenusConfig = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const [rol, setRol] = useState({});
    const [inListPri, setInListPri] = useState([]);
    const [exListPri, setExListPri] = useState([]);
    const [inListSec, setInListSec] = useState([]);
    const [exListSec, setExListSec] = useState([]);
    const [disabledAddPri, setDisabledAddPri] = useState(true);
    const [disabledRemPri, setDisabledRemPri] = useState(true);
    const [disabledAddSec, setDisabledAddSec] = useState(true);
    const [disabledRemSec, setDisabledRemSec] = useState(true);
    const [selectedMenu, setSelectedMenu] = useState({});
    

    useEffect(() => {
        init();
    }, [props.content]);

    const init = () => {
        setDisabledAddPri(true);
        setDisabledRemPri(true);
        setDisabledAddSec(true);
        setDisabledRemSec(true);
        if(props.content){
            if(props.content.rol){
                setRol(JSON.parse(JSON.stringify(props.content.rol)));
            }
            if(props.content.principal){
                if(props.content.principal.in){
                    setInListPri(JSON.parse(JSON.stringify(props.content.principal.in)));
                }
                if(props.content.principal.ex){
                    setExListPri(JSON.parse(JSON.stringify(props.content.principal.ex)));
                }
            }

            if(props.content.secondary){
                if(props.content.secondary.in){
                    setInListSec(JSON.parse(JSON.stringify(props.content.secondary.in)));
                }
                if(props.content.secondary.ex){
                    setExListSec(JSON.parse(JSON.stringify(props.content.secondary.ex)));
                }
            }
            setSelectedMenu({});
        }
    }

    const selectItem = (type, typeMenu, index) => {
        let list = [];
        if(typeMenu == 'principal'){
            let inS = inListSec;
            let exS = exListSec;
            for(let i = 0; i<inS.length; i++){
                inS[i]['checked'] = false;
            }
            for(let i = 0; i<exS.length; i++){
                exS[i]['checked'] = false;
            }
            setExListSec(JSON.parse(JSON.stringify(exS)));
            setInListSec(JSON.parse(JSON.stringify(inS)));
            if(type == 'ex'){
                list = exListPri;
                let inL = inListPri;
                
                list[index]['checked'] = list[index]['checked'] ? !list[index]['checked'] : true;
                setSelectedMenu(JSON.parse(JSON.stringify(list[index])));
                for(let i = 0; i<list.length; i++){
                    if(i != index){
                        list[i]['checked'] = list[i]['checked'] ? !list[i]['checked'] : false;
                    }
                }
    
                for(let i = 0; i<inL.length; i++){
                    inL[i]['checked'] = false;
                }
                setExListPri(JSON.parse(JSON.stringify(list)));
                setInListPri(JSON.parse(JSON.stringify(inL)));
            }
    
            if(type == 'in'){
                list = inListPri;
                let exL = exListPri;
                list[index]['checked'] = list[index]['checked'] ? !list[index]['checked'] : true;
                setSelectedMenu(JSON.parse(JSON.stringify(list[index])));
                for(let i = 0; i<list.length; i++){
                    if(i != index){
                        list[i]['checked'] = list[i]['checked'] ? !list[i]['checked'] : false;
                    }
                }
    
                for(let i = 0; i<exL.length; i++){
                    exL[i]['checked'] = false;
                }
    
                setInListPri(JSON.parse(JSON.stringify(list)));
                setExListPri(JSON.parse(JSON.stringify(exL)));
            }
        }

        if(typeMenu == 'secondary'){
            let inP = inListPri;
            let exP = exListPri;
            for(let i = 0; i<inP.length; i++){
                inP[i]['checked'] = false;
            }
            for(let i = 0; i<exP.length; i++){
                exP[i]['checked'] = false;
            }
            setExListPri(JSON.parse(JSON.stringify(exP)));
            setInListPri(JSON.parse(JSON.stringify(inP)));
            if(type == 'ex'){
                list = exListSec;
                let inL = inListSec;
                list[index]['checked'] = list[index]['checked'] ? !list[index]['checked'] : true;
                setSelectedMenu(JSON.parse(JSON.stringify(list[index])));
                for(let i = 0; i<list.length; i++){
                    if(i != index){
                        list[i]['checked'] = list[i]['checked'] ? !list[i]['checked'] : false;
                    }
                }
    
                for(let i = 0; i<inL.length; i++){
                    inL[i]['checked'] = false;
                }
                setExListSec(JSON.parse(JSON.stringify(list)));
                setInListSec(JSON.parse(JSON.stringify(inL)));
            }
    
            if(type == 'in'){
                list = inListSec;
                let exL = exListSec;
                list[index]['checked'] = list[index]['checked'] ? !list[index]['checked'] : true;
                setSelectedMenu(JSON.parse(JSON.stringify(list[index])));
                for(let i = 0; i<list.length; i++){
                    if(i != index){
                        list[i]['checked'] = list[i]['checked'] ? !list[i]['checked'] : false;
                    }
                }
    
                for(let i = 0; i<exL.length; i++){
                    exL[i]['checked'] = false;
                }
    
                setInListSec(JSON.parse(JSON.stringify(list)));
                setExListSec(JSON.parse(JSON.stringify(exL)));
            }
        }

        validate(type, typeMenu, list);
    }

    const validate = (type, typeMenu, list) => {
        let t = 0;
        for(let i = 0; i<list.length; i++){
            if(list[i]['checked']){
                t = 1;
                break;
            }
        }

        if(typeMenu == 'principal'){
            setDisabledAddSec(true);
            setDisabledRemSec(true);
            if(type == 'ex'){
                setDisabledRemPri(true);
                if(t){
                    setDisabledAddPri(false);
                }else{
                    setDisabledAddPri(true);
                }
            }
    
            if(type == 'in'){
                setDisabledAddPri(true);
                if(t){
                    setDisabledRemPri(false);
                }else{
                    setDisabledRemPri(true);
                }
            }
        }

        if(typeMenu == 'secondary'){
            setDisabledAddPri(true);
            setDisabledRemPri(true);
            if(type == 'ex'){
                setDisabledRemSec(true);
                if(t){
                    setDisabledAddSec(false);
                }else{
                    setDisabledAddSec(true);
                }
            }
    
            if(type == 'in'){
                setDisabledAddSec(true);
                if(t){
                    setDisabledRemSec(false);
                }else{
                    setDisabledRemSec(true);
                }
            }
        }

        
    }

    const editMenu = async (typeMenu, type) => {
        props.changeLoader(true);
        let data = {
            key: selectedMenu['key'],
            action: type,
            roles: [rol['uuid']],
            type: typeMenu
        };

        let request = await API.service('updateMenus', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let req = await API.service('findMenus', {uuid: rol['uuid']}, props.pos, props.changeAlert, props.changeLoader, history);
            if (req.status == 200 && req.data.data.response == "OK") {
                let widg = [];
                widg = req.data.data.widget;
                if (widg[0].type == 'menusConfig' && widg[0].content) {
                    let w = props.widgets[0];
                    let widgUpdate = [w, widg[0]];
                    props.changeWidgets(JSON.parse(JSON.stringify(widgUpdate)));
                }
            }
        }
        props.changeLoader(false);
    }

    
    return <Paper sx={{width: '100%', marginTop: '1%'}}>
        <Typography
            component="div"
            children={
                <div className={classes.titleTable}>
                    <h2 className={classes.titleH2}>
                        <Settings className={classes.iconTitle}/>
                        <Typography component={'span'} fontWeight={'bold'} fontFamily={'Muli,sans-serif'} fontSize={'18px'}>
                            Menu {rol['name']}
                        </Typography>
                    </h2>
                </div>
            }
            fontWeight="bold"
            fontFamily="Muli,sans-serif"
            fontSize="20px"
        />

        <Grid container spacing={2} width={"auto"} sx={{marginLeft: '0px'}} mt={0}>
            <Grid item width={"21%"}>
                <Card>
                    <CardHeader 
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Menu principal no agregado
                            </Typography>
                        }
                        subheader={
                            <Typography component={'div'} fontFamily="Muli,sans-serif" fontSize="14px" >
                                {`Total: ${exListPri.length}`}
                            </Typography>
                        }
                    />
                    <Divider/>
                    <List sx={{height: '300px', overflow: 'auto'}}>
                        {
                            exListPri.map((item, index) => {
                                return <ListItem key={`add-${index}`} sx={{padding: "2px 8px"}}>
                                    <ListItemIcon>
                                        <Checkbox checked={item.checked ? item.checked : false} onChange={selectItem.bind(this, 'ex', 'principal', index)} color='secondary'/>
                                    </ListItemIcon>
                                    <ListItemText primary={item.key}/>
                                </ListItem>
                            })
                        }
                    </List>
                </Card>
            </Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <Tooltip title="Agregar">
                        <IconButton color="secondary" disabled={disabledAddPri} onClick={editMenu.bind(this, 'principal', 'add')}>
                            <Add/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton color="secondary" disabled={disabledRemPri} onClick={editMenu.bind(this, 'principal', 'delete')}>
                            <Remove/>
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <Grid item width={"21%"}>
                <Card>
                    <CardHeader 
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Menu principal agregado
                            </Typography>
                        }
                        subheader={
                            <Typography component={'div'} fontFamily="Muli,sans-serif" fontSize="14px" >
                                {`Total: ${inListPri.length}`}
                            </Typography>
                        }
                    />
                    <Divider/>
                    <List sx={{height: '300px', overflow: 'auto'}}>
                        {
                            inListPri.map((item, index) => {
                                return <ListItem key={`delete-${index}`} sx={{padding: "2px 8px"}}>
                                    <ListItemIcon>
                                        <Checkbox checked={item.checked ? item.checked : false} onChange={selectItem.bind(this, 'in', 'principal', index)} color='secondary'/>
                                    </ListItemIcon>
                                    <ListItemText primary={item.key}/>
                                </ListItem>
                            })
                        }
                    </List>
                </Card>
            </Grid>
            <Grid item width={"3%"}></Grid>
            <Grid item width={"21%"}>
                <Card>
                    <CardHeader 
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Menu secundario no agregado
                            </Typography>
                        }
                        subheader={
                            <Typography component={'div'} fontFamily="Muli,sans-serif" fontSize="14px" >
                                {`Total: ${exListSec.length}`}
                            </Typography>
                        }
                    />
                    <Divider/>
                    <List sx={{height: '300px', overflow: 'auto'}}>
                        {
                            exListSec.map((item, index) => {
                                return <ListItem key={`add-${index}`} sx={{padding: "2px 8px"}}>
                                    <ListItemIcon>
                                        <Checkbox checked={item.checked ? item.checked : false} onChange={selectItem.bind(this, 'ex', 'secondary', index)} color='secondary'/>
                                    </ListItemIcon>
                                    <ListItemText primary={item.key}/>
                                </ListItem>
                            })
                        }
                    </List>
                </Card>
            </Grid>
            <Grid item >
                <Grid container direction="column" alignItems="center">
                    <Tooltip title="Agregar">
                        <IconButton color="secondary" disabled={disabledAddSec} onClick={editMenu.bind(this, 'secondary', 'add')}>
                            <Add/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton color="secondary" disabled={disabledRemSec} onClick={editMenu.bind(this, 'secondary', 'delete')}>
                            <Remove/>
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <Grid item width={"21%"}>
                <Card>
                    <CardHeader 
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Menu secundario agregado
                            </Typography>
                        }
                        subheader={
                            <Typography component={'div'} fontFamily="Muli,sans-serif" fontSize="14px" >
                                {`Total: ${inListSec.length}`}
                            </Typography>
                        }
                    />
                    <Divider/>
                    <List sx={{height: '300px', overflow: 'auto'}}>
                        {
                            inListSec.map((item, index) => {
                                return <ListItem key={`delete-${index}`} sx={{padding: "2px 8px"}}>
                                    <ListItemIcon>
                                        <Checkbox checked={item.checked ? item.checked : false} onChange={selectItem.bind(this, 'in', 'secondary', index)} color='secondary'/>
                                    </ListItemIcon>
                                    <ListItemText primary={item.key}/>
                                </ListItem>
                            })
                        }
                    </List>
                </Card>
            </Grid>
        </Grid>
    </Paper>
}

export default MenusConfig;